import React from "react";
import { ConnectButton } from '@rainbow-me/rainbowkit';
//import logo from '../../logo.png';
import logoheader from '../../logo-header.png';
import { Text, Button, Row } from '@nextui-org/react';
import "./Header.css";

export default function Header() {
  return (
    <div className="header">
    <div style={{ display: 'block', width: '90%' }}>
        <Row justify="space-between">

          <img src={logoheader} className="header-logo" alt="logo" />

          <ConnectButton showBalance={false} />

        </Row>
      </div>
    </div>
  );
}
/*
          <Button
            css={{ boxShadow:'0px 2px 12px #314e86' }}
            shadow 
            color="gradient" ><b>Connect Wallet</b>
          </Button>


*/